
import { Component, Vue } from 'vue-property-decorator';

import Trail from './Trail.vue';
import FormIcon from './journeyicons/FormIcon.vue';
import GavelEndCircle from './journeyicons/GavelEndCircle.vue';

import InstructionWindowFooter from '../components/InstructionWindowFooter.vue';
import PathSidebar from '../components/PathSidebar.vue';
import InitialDocumentsAppApplyLeavePg from '../components/AppApplyLeave/InitialDocumentsAppApplyLeavePg.vue';
import HearingDocumentsMotionAppApplyLeavePg from '../components/AppApplyLeave/HearingDocumentsMotionAppApplyLeavePg.vue';
import DecisionOnLeaveToAppealAppApplyLeavePg from '../components/AppApplyLeave/DecisionOnLeaveToAppealAppApplyLeavePg.vue';

import {activatePage, evaluateCompletedTrails, evaluatePageState} from '@/components/utils/TrailOperations'

import { namespace } from "vuex-class";
import "@/store/modules/application";
const applicationState = namespace("Application")
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

@Component({
    components:{
        Trail,
        FormIcon,
        GavelEndCircle,
        InstructionWindowFooter,
        PathSidebar,       
        InitialDocumentsAppApplyLeavePg,       
        HearingDocumentsMotionAppApplyLeavePg,
        DecisionOnLeaveToAppealAppApplyLeavePg
    }
})

export default class AppellantApplyForLeaveJourneyMap extends Vue {

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;
    
    showWindow = false;
    windowTitle = '';
    pathTypes = [] as string[];
    pathHeights = [] as string[];

    dataReady = false;
    completedTrail :boolean[] = []
    numOfPages = 0;
    currentStep = 0;
    pageState : {active:boolean; status:string; ready:boolean;}[] = []


    initialDocumentsContent = false;
    hearingDocumentsContent = false;
    decisionOnLeaveContent = false;

    mounted(){
        this.dataReady = false;

        this.currentStep = this.stPgNo.APP_APPLY_LEAVE._StepNo;
        this.numOfPages = Object.keys(this.stPgNo.APP_APPLY_LEAVE).length-1;
        this.getJourneyMapCurrentState();
        
        this.dataReady = true;
    }

    public completed(order, checked){        
        activatePage(order, checked, this.currentStep)
        this.getJourneyMapCurrentState();
    }

    public getJourneyMapCurrentState(){
        this.completedTrail = evaluateCompletedTrails(this.numOfPages, this.currentStep);
        this.pageState = evaluatePageState(this.numOfPages, this.currentStep);
    }

    public displayWindow(contentType: string){

        this.initialDocumentsContent = false;
        this.hearingDocumentsContent = false;
        this.decisionOnLeaveContent = false;

        if (contentType == "Initial Document"){

            this.windowTitle = "Initial Document";
            this.pathTypes = ["share"];
            this.pathHeights = ['28rem'];
            this.initialDocumentsContent = true;

        } else if (contentType == "Hearing Documents"){

            this.windowTitle = "Hearing Documents";
            this.pathTypes = ["share"];
            this.pathHeights = ['16rem'];
            this.hearingDocumentsContent = true;

        } else if (contentType == "Decision on Leave"){
            
            this.windowTitle = "Decision on Leave to Appeal";
            this.pathTypes = ["gavel"];
            this.pathHeights = ['0'];
            this.decisionOnLeaveContent = true;
        }         
        this.showWindow = true;
    }

}
